import { LogEntry } from "../Models/monitoring";

const LOG_LINE_REGEX =
  /^(\d{4}-\d{2}-\d{2}\s+\d{2}:\d{2}:\d{2},\d+)\s+-\s+\w+\s+-\s+(\w+)\s+-\s+(.*)$/;

export const parseLogs = (raw: string): LogEntry[] => {
  if (!raw) return [];

  return raw
    .split("\n")
    .filter((line) => line.trim())
    .map((line) => {
      const match = line.match(LOG_LINE_REGEX);
      if (match) {
        return {
          timestamp: match[1],
          level: match[2],
          message: match[3],
        };
      }
      return { timestamp: "", level: "UNKNOWN", message: line };
    });
};

/**
 * Parse multiline error logs. Each entry starts with a structured log line,
 * optionally followed by traceback lines (indented or starting with "Traceback",
 * "File ", "During", etc.).
 */
export const parseErrorLogs = (raw: string): LogEntry[] => {
  if (!raw) return [];

  const lines = raw.split("\n");
  const entries: LogEntry[] = [];
  let currentEntry: LogEntry | null = null;
  let tracebackLines: string[] = [];

  const flushEntry = () => {
    if (currentEntry) {
      if (tracebackLines.length > 0) {
        currentEntry.traceback = tracebackLines.join("\n");
      }
      entries.push(currentEntry);
      currentEntry = null;
      tracebackLines = [];
    }
  };

  for (const line of lines) {
    const match = line.match(LOG_LINE_REGEX);
    if (match) {
      // New structured log entry found — flush the previous one
      flushEntry();
      currentEntry = {
        timestamp: match[1],
        level: match[2],
        message: match[3],
      };
    } else if (currentEntry && line.trim()) {
      // Continuation line (traceback, exception text, etc.)
      tracebackLines.push(line);
    }
  }

  // Flush last entry
  flushEntry();

  return entries;
};
